import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const ProfitAndLossApi = {
  getCalculationsOfProfitAndLoss: async (params: t.IUpdateProfitAndLossCalculationsParams) => {
    const { businessPlanId, unit, profitAndLossData } = params;
    const { data } = await businessPlanAxios.put<t.IProfitAndLossCalculationResponse>(
      `/${businessPlanId}/profitandloss/${unit}`,
      profitAndLossData,
    );
    return data;
  },
};

